import { withErrorBoundary } from "@sentry/nextjs";
import { useEffect } from "react";
import { ApplicationErrorFallback } from "components/ApplicationErrorFallback";
import { BannerProvider } from "context/banner";
import { DisclosuresProvider } from "context/disclosures";
import { dynamicComponentList } from "lib/dynamicComponentList";
import { StylesProvider } from "styles";
import "styles/globals.css";
import "styles/tokens/Fonts.css";
import { initializeTracking, onPageChange } from "../lib/tracking";
import type { AppProps } from "next/app";

typeof window !== "undefined" && initializeTracking();
function MyApp({ Component, pageProps, router }: AppProps) {
  useEffect(() => {
    router.events.on("routeChangeComplete", onPageChange);

    return () => {
      router.events.off("routeChangeComplete", onPageChange);
    };
  }, [router.events]);

  return (
    <StylesProvider>
      <BannerProvider>
        <DisclosuresProvider>
          <Component {...pageProps} dynamicComponentList={dynamicComponentList} />
        </DisclosuresProvider>
      </BannerProvider>
    </StylesProvider>
  );
}

export default withErrorBoundary(MyApp, { fallback: <ApplicationErrorFallback /> });
